// SEO Configuration
export const seoConfig = {
  "businessName": "Monroe Davis",
  "home": {
    "title": "Homes by Monroe Davis – Expert Real Estate Guidance in the Tri-Cities",
    "description": "Discover personalized real estate service with Monroe Davis, offering deep market expertise and exceptional support to help you achieve your property goals.",
    "keywords": "Monroe Davis, real estate, Tri-Cities, expert guidance, personalized service"
  },
  "about": {
    "title": "About Monroe Davis",
    "description": "Learn about Monroe Davis's commitment to turning your home search into an effortless, joyful journey with deep local market expertise.",
    "keywords": "Monroe Davis, Tri-Cities, real estate, trusted advisor"
  },
  "contact": {
    "title": "Contact Monroe Davis",
    "description": "Reach out to Monroe Davis for expert real estate advice and personalized support in the Tri-Cities.",
    "keywords": "contact, real estate, Tri-Cities, Monroe Davis"
  }
};

// Default export for better module compatibility
export default seoConfig;